import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './internalerror.component.html',
    styleUrls: ['./internalerror.component.scss'],
    standalone: false
})
export class InternalErrorComponent implements OnInit {
  
  constructor() { }

  ngOnInit() {
  }

}
